import React from 'react';

import './FAQ.css';
import {ReactComponent as ArrowDownIcon} from "../../images/icons/arrow-down.svg";
import API from "../../components/api";
import Utils from "../../utils";
import Linkify from 'linkify-react'


class FAQPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            accordionTabActive: 0,

            questions: []
        }

        this.setAccordionTab = (index) => {
            if (this.state.accordionTabActive === index) {
                this.setState({accordionTabActive: null})

                this.state.questions.forEach((question, thisIndex) => {
                    const container = document.getElementById(`question-${thisIndex}`);
                    container.style.height = '0px';
                })
            } else {
                this.setState({accordionTabActive: index})

                this.state.questions.forEach((question, thisIndex) => {
                    if (thisIndex === index) {
                        const container = document.getElementById(`question-${thisIndex}`);
                        container.style.height = container.scrollHeight + (16 * 2) + 'px';
                    } else {
                        const container = document.getElementById(`question-${thisIndex}`);
                        container.style.height = '0px';
                    }
                })
            }
        }
    }

    componentDidMount() {
        Utils.setPageTitle('Частые вопросы')

        API.getFAQPage()
            .then(data => this.setState({questions: data}))
            .catch(() => {
            })
    }

    render() {
        return <div className='faq-page'>
            <div className='page'>
                <div className='block'>
                    <div className='header'>
                        Частые вопросы
                    </div>
                    <div className='column'>
                        <div className='questions'>
                            {this.state.questions.map((question, index) => {
                                const classList = ['question']

                                if (this.state.accordionTabActive === index) classList.push('active')

                                return <div key={index} className={classList.join(' ')}
                                            onClick={() => this.setAccordionTab(index)}>
                                    <div className='head'>
                                        <div className='arrow'>
                                            <ArrowDownIcon/>
                                        </div>
                                        <div className='title'>{question.question}</div>
                                    </div>
                                    <div id={`question-${index}`} className='description'>
                                        <Linkify
                                            options={{
                                                target: '_blank',
                                                rel: 'noopener noreferrer',
                                                className: 'faq-link'
                                            }}
                                        >
                                            {question.answer}
                                        </Linkify>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}


export default FAQPage;
